import React from 'react';

import { FooterWrapper } from './styles';

export default function Footer() {
  return (
    <FooterWrapper>
      <p>Copyright &copy; peerLab 2020</p>
    </FooterWrapper>
  );
}
